import { render } from "./ExampleDeviceScreenWifi.vue?vue&type=template&id=1ba3a936&scoped=true&ts=true&lang=pug"
import script from "./ExampleDeviceScreenWifi.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExampleDeviceScreenWifi.vue?vue&type=script&lang=ts&setup=true"

import "./ExampleDeviceScreenWifi.vue?vue&type=style&index=0&id=1ba3a936&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ba3a936"]])

export default __exports__